import { useCallback, useId } from 'react';
import { useFormsItemsListQuery } from '@/modules/admin-dashboard/queries/forms.ts';
import { SelectPaginate, SelectPaginateOption } from 'ui';

type baseProps = {
  label?: string;
  error?: string;
  disabled?: boolean;
  className?: string;
  isClearable?: boolean;
  placeholder?: string;
};

type singleProps = {
  isMulti: false;
  onChange: (options: SelectPaginateOption<string>) => void;
  defaultValue?: SelectPaginateOption<string>;
  value?: SelectPaginateOption<string> | null;
};

type multiProps = {
  isMulti: true;
  onChange: (options: SelectPaginateOption<string>[]) => void;
  defaultValue?: SelectPaginateOption<string>[];
  value?: SelectPaginateOption<string>[];
};

type FormSelectPaginateProps = baseProps & (singleProps | multiProps);

const FormSelectPaginate = ({
  label,
  error,
  value,
  isMulti,
  className,
  disabled,
  placeholder,
  isClearable,
  defaultValue,
  onChange,
}: FormSelectPaginateProps) => {
  const { fetchNextPage } = useFormsItemsListQuery(
    { page: 1, page_size: 15, filter_by_name: '', filter_key: 'compliance', filter_value: 'true' },
    { disabled: true, cacheKey: useId() },
  );

  const handleAsyncLoadFormOptions = useCallback(
    async (page: number, search?: string) => {
      const formsData = await fetchNextPage({ pageParam: { page, search } });

      const forms = formsData?.data?.pages?.at(-1)?.data || [];
      return forms.map(({ id, label }) => ({
        label,
        value: id,
      }));
    },
    [fetchNextPage],
  );
  return (
    <SelectPaginate
      disabled={disabled}
      isMulti={isMulti}
      label={label}
      className={className}
      placeholder={placeholder}
      defaultValue={defaultValue}
      onAsync={handleAsyncLoadFormOptions}
      onChange={options => onChange(options as any)}
      error={error}
      value={value}
      isClearable={isClearable}
    />
  );
};

export default FormSelectPaginate;
